import styled from 'styled-components';
import { Text } from '@comicrelief/component-library';

const OuterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color:  ${({ theme, pageBackgroundColour }) => theme.color(pageBackgroundColour)};
`;

// Smooth(ish)ly show the Gallery once it's ready
const ComponentWrapper = styled.div`
  transition: opacity ease-in 0.25s;
  opacity: ${({ show }) => (show ? '1' : '0')};
  height: ${({ show }) => (show ? 'auto' : '0')};
  width: ${({ show }) => (show ? 'auto' : '0')};
`;

// Arbitrary but realistic size while we're waiting on things o load
const LoaderWrapper = styled.div`
  padding: 25vh 0;
`;

const NodeTitle = styled(Text)`
  display: block;
  font-size: 1rem;
  line-height: 1rem;
`;

const NodeCaption = styled(Text)`
  display: block;
  font-size: 0.75rem;
  line-height: 0.75rem;
`;

export {
  OuterWrapper, ComponentWrapper, LoaderWrapper, NodeTitle, NodeCaption
};
